'use strict';

var REACT_BASE_PATH = window.location.port === '3001'
  ? 'http://localhost:3000'
  : '/v2/web/index.html';

var FLAG_ID = 'global-search-v2-nav';

function reactUrl(path) {
  return REACT_BASE_PATH + '#' + path;
}

var ReactNavigationService = /*@ngInject*/ function($window, $location, $state, FeatureFlagService) {
  function isEnabled() {
    return FeatureFlagService.isEnabled(FLAG_ID);
  }

  this.goToSearch = function(query) {
    if (!isEnabled()) {
      $state.go('search', { q: query });
      return;
    }
    var term = query || '*';
    $window.location.assign(reactUrl('/search?term=' + encodeURIComponent(term) + '&type=All'));
  };

  this.goToJobDetail = function(jobId) {
    if (!isEnabled()) {
      $window.open(reactUrl('/job/' + jobId), '_blank');
      return;
    }
    $window.location.assign(reactUrl('/job/' + jobId));
  };

  this.goToProductDetail = function(productId) {
    if (!isEnabled()) {
      $state.go('detail', {
        productIdentifierType: 'by-product-id',
        productIdentifier: productId
      });
      return;
    }
    $window.location.assign(reactUrl('/product/' + productId));
  };

  this.goToQAQueue = function() {
    var fromReact = $location.search().source === 'react';
    if (!isEnabled() && !fromReact) {
      $state.go('queue.qa');
      return;
    }
    var tab = $location.search().tab || 'unassigned';
    $window.location.assign(reactUrl('/queues/qa?tab=' + tab));
  };

  this.goToPostProdQueue = function() {
    if (!isEnabled()) {
      $state.go('queue.post-prod');
      return;
    }
    $window.location.assign(reactUrl('/queues/post-prod?tab=unassigned'));
  };

  this.goToAdmin = function(section) {
    if (!isEnabled()) {
      $state.go('admin', { section: section });
      return;
    }
    $window.location.assign(reactUrl('/admin/' + section));
  };

  this.goToHome = function() {
    if (!isEnabled()) {
      $state.go('search');
      return;
    }
    $window.location.assign(reactUrl('/'));
  };

  this.isEnabled = isEnabled;

  this.buildUrl = reactUrl;
};

module.exports = ReactNavigationService;
